import React from 'react';
import Modal from '../comm/Modal';
const AlertBox = ({ isOpen, setIsOpen, onCloseCallback, message, leftBtnTxt, rightBtnTxt, children }) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
            <div className='modal-box' data-type="a">
                <div className='modal-top-box'>
                    <div className='title-box'>
                        <p>{message}</p>
                    </div>
                </div>
                {children}
                <div className="modal-bottom-box">
                    <div className='btn-layout'>
                        <button className="btn" data-btn-type="fill-main" data-btn-size="md"
                                onClick={() => onCloseCallback(true)}> {/* 긍정 .. */}
                            <span>{'확인'}</span>
                        </button>

                    </div>
                </div>
            </div>
        </Modal>
)
}

export default AlertBox;
